module.exports = __webpack_public_path__ + "img/umbro.3bb44a73.png";